var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-videos"},[_c('div',{staticStyle:{"width":"97%","margin":"auto"}},[_c('van-cell',{staticStyle:{"background-color":"#dddddd"},attrs:{"title":"企业视频区","value":"更多","is-link":""}})],1),_c('div',{staticStyle:{"width":"97%","margin":"auto","padding":"0px 8px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }